interface HubSpotFormData {
  name: string;
  email: string;
  company?: string;
  message: string;
}

interface HubSpotSubmissionResponse {
  success: boolean;
  message?: string;
}

export const submitToHubSpot = async (
  formData: HubSpotFormData
): Promise<HubSpotSubmissionResponse> => {
  const portalId = "147362168";
  const formId = "dbfeab2f-904c-47bd-9b47-9a70baa29ef9";

  const url = `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formId}`;

  const hubspotPayload = {
    fields: [
      {
        objectTypeId: "0-1",
        name: "firstname",
        value: formData.name.split(" ")[0] || formData.name,
      },
      {
        objectTypeId: "0-1",
        name: "lastname",
        value: formData.name.split(" ").slice(1).join(" ") || "",
      },
      {
        objectTypeId: "0-1",
        name: "email",
        value: formData.email,
      },
      {
        objectTypeId: "0-1",
        name: "company",
        value: formData.company || "",
      },
      {
        objectTypeId: "0-1",
        name: "message",
        value: formData.message,
      },
    ],
    context: {
      pageUri: window.location.href,
      pageName: "Contact Page",
    },
  };

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(hubspotPayload),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      console.error("HubSpot API error:", errorData);
      throw new Error(`HubSpot submission failed: ${response.statusText}`);
    }

    return {
      success: true,
      message: "Form submitted successfully to HubSpot",
    };
  } catch (error) {
    console.error("Error submitting to HubSpot:", error);
    throw error;
  }
};
